// Sync validators
export const checked =
  () =>
  (val = false) =>
    val
export const required =
  () =>
  (val = '') =>
    !!val && val.trim().length > 0
export const length =
  ({ min, max }) =>
  (val = '') =>
    !!val && val.length >= min && val.length <= max
export const phone =
  () =>
  (val = '') =>
    /^([+]|[0]{1})?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/.test(val)

export const emailPattern = '^\\w+([.]?[\\w+-])*@\\w+([.]?[\\w-])*(\\.\\w{2,})$'
export const emailRegex = /^\w+([.]?[\w+-])*@\w+([.]?[\w-])*(\.\w{2,})$/
export const email =
  () =>
  (val = '') =>
    emailRegex.test(val)

// Async validators
export const available =
  ({ isAvailable }) =>
  (val = '', done) =>
    isAvailable(val).then(({ result: exists }) => done(!exists))

export const hasSpecialCharacter = (str) => {
  return /[^0-9A-Za-z]/.test(str)
}

export const password =
  () =>
  (val = '') => {
    return (
      !!/[A-Z]+/.test(val) &&
      !!/[a-z]+/.test(val) &&
      !!/[0-9]+/.test(val) &&
      val.length >= 8 &&
      val.length < 100 &&
      hasSpecialCharacter(val)
    )
  }
